import { Component, Input } from "@angular/core";
import { LensSide } from "../catalog.service";

@Component({
    selector: 'app-lens-side-circle',
    templateUrl: './lens-side-circle.component.html',
    styleUrls: ['./lens-side-circle.component.scss']
  })
  export class LensSideCircleComponent {

    @Input() side: LensSide;

    sideLetter = {
      RIGHT: "R",
      LEFT: "L"
    };

  }